import React, { FC } from 'react';
import { CommissionsByClientReport } from '../CommissionsByClientModel';
import { DataTable, ColumnConfig } from '../../DataTable';

interface Props {
  translation: any;
  groupByOption: string | undefined;
  columns: ColumnConfig<CommissionsByClientReport>[];
  selectedColumns: string[];
  rows: CommissionsByClientReport[];
  onSelectColumns(columns: string[]): void;
}

export const PartnershipReports: FC<Props> = ({ columns, selectedColumns, groupByOption, rows, translation, onSelectColumns }) => (
  <DataTable columns={columns} data={rows} translation={translation} columnSelect selectedColumns={selectedColumns} onSelectColumns={onSelectColumns} groupByKey={groupByOption || undefined} emptyMessage={translation.text_6448} />
);
